import { render, staticRenderFns } from "./TwoStepFaq.vue?vue&type=template&id=2538b962&scoped=true"
import script from "./TwoStepFaq.vue?vue&type=script&lang=js"
export * from "./TwoStepFaq.vue?vue&type=script&lang=js"
import style0 from "./TwoStepFaq.vue?vue&type=style&index=0&id=2538b962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538b962",
  null
  
)

export default component.exports